export default "__VITE_ASSET__DKqTppye__"